/** Sentinel keys — must not collide with real Firestore document ids. */
export const NO_UID_KEY = "__none__";
export const NO_WEDDING_KEY = "__none__";
export const NO_PLAN_KEY = "__none__";

const PLAN_KEY_SEP = "::";

/** Composite key for plan-scoped collections (tables, roomElements). */
export function planScopedKey(weddingId: string, planId: string): string {
  return `${weddingId}${PLAN_KEY_SEP}${planId}`;
}

/** Split a plan-scoped subscription key; null when key is a sentinel or malformed. */
export function parsePlanScopedKey(key: string): { weddingId: string; planId: string } | null {
  if (key === NO_WEDDING_KEY || key === NO_PLAN_KEY) return null;
  const sep = key.indexOf(PLAN_KEY_SEP);
  if (sep <= 0 || sep === key.length - PLAN_KEY_SEP.length) return null;
  return {
    weddingId: key.slice(0, sep),
    planId: key.slice(sep + PLAN_KEY_SEP.length),
  };
}
